import React, { useState, useEffect } from 'react';
import api from '../services/api';

function MysticBots() {
  const [bots, setBots] = useState([]);
  const [currentBot, setCurrentBot] = useState(null);
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const fetchBots = async () => {
      try {
        const data = await api.get('/scripts/mystic-bots');
        setBots(data);
        if (data.length > 0) {
          setCurrentBot(data[0]);
          setContent(data[0].content);
        }
      } catch (err) {
        console.error('Failed to fetch mystic bots:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchBots();
  }, []);

  const handleSelectBot = (bot) => {
    setCurrentBot(bot);
    setContent(bot.content);
  };

  const handleSave = async () => {
    if (!currentBot) return;
    setSaving(true);
    setMessage(null);
    try {
      await api.put(`/scripts/${currentBot.path}`, { content });
      setMessage({ type: 'success', text: 'Mystic bot saved successfully!' });
    } catch (err) {
      setMessage({ type: 'error', text: 'Failed to save mystic bot.' });
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="card">Loading mystic bots...</div>;

  return (
    <div>
      <div className="page-header">
        <h2>Mystic Bots</h2>
        <p>Configure Mystic bot templates (tt1 - tt9)</p>
      </div>

      {message && (
        <div className={`alert alert-${message.type}`}>{message.text}</div>
      )}

      <div className="two-col">
        <div className="card">
          <div className="card-title">Bot Templates</div>
          <div className="script-tree">
            {bots.map((bot, idx) => (
              <div
                key={idx}
                className={`tree-item file ${currentBot?.name === bot.name ? 'active' : ''}`}
                onClick={() => handleSelectBot(bot)}
              >
                🔮 {bot.name}
              </div>
            ))}
          </div>
        </div>

        <div className="card">
          <div className="card-title">
            {currentBot ? `Editing: ${currentBot.name}` : 'No bot selected'}
          </div>
          {currentBot && (
            <>
              <div className="form-group">
                <textarea
                  value={content}
                  onChange={e => setContent(e.target.value)}
                  spellCheck={false}
                />
              </div>
              <div className="btn-group">
                <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
                  {saving ? 'Saving...' : 'Save Bot'}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default MysticBots;
